class RecentCollectionBreadcrumb extends HTMLElement {
  connectedCallback () {
    if (!sessionStorage.getItem('BAO-recent-collection')) {
      this.parentElement.remove();
      return;
    }
    const { collection } = JSON.parse(sessionStorage.getItem('BAO-recent-collection'))

    // Removes the product breadcrumb if collection item exists.
    this.parentElement.nextElementSibling.remove();

    this.innerHTML = `
      <a class="fostr-breadcrumbs__link" href="${collection.url}">${collection.name}</a>
    `
  }
}

if (!customElements.get('collection-breadcrumb')) {
  customElements.define('collection-breadcrumb', RecentCollectionBreadcrumb)
}